import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import router from './router'

import baseUrl from './utils/baseUrl.js'
Vue.prototype.$Url=baseUrl.Api

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
